class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelectorAll(".cart-open-trigger");
    cartLink.forEach((links) => {
      links.setAttribute("role", "button");
      links.setAttribute("aria-haspopup", "dialog");
      links.addEventListener("click", (event) => {
        event.preventDefault();
        this.open(links);
      });
      links.addEventListener("keydown", (event) => {
        if (event.code.toUpperCase() === "SPACE") {
          event.preventDefault();
          this.open(links);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNotes = this.querySelectorAll('[id^="Details-"] summary');
    cartDrawerNotes.forEach((summary) => {
      if (!summary.hasAttribute("role")) this.setSummaryAccessibility(summary);
    });
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    if (parsedState.product_id) {
      window.driver13ComplementaryProductId =
        String(parsedState.product_id);

      try {
        sessionStorage.setItem(
          "driver13-complementary-product-id",
          String(parsedState.product_id)
        );
      } catch (error) {
        // Funktioniert auch ohne verfügbaren Sitzungsspeicher.
      }
    }
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
      {
        id: "cart-icon-bubble-mobile",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-icon-bubble-mobile",
        section: "cart-icon-bubble-mobile",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

if (!customElements.get("driver13-cart-complementary")) {
  customElements.define(
    "driver13-cart-complementary",
    class extends HTMLElement {
      connectedCallback() {
        if (!this.submitHandler) {
          this.submitHandler = this.handleSubmit.bind(this);
          this.addEventListener("submit", this.submitHandler);
        }
        // Erst nach dem Einfügen aller Kind-Elemente ausführen.
        queueMicrotask(() => {
          if (!this.isConnected) return;

          const templates = Array.from(
            this.querySelectorAll("template[data-product-id]")
          );
          const output = this.querySelector(
            "[data-complementary-output]"
          );

          if (!output || !templates.length) return;

          let preferredProductId =
            window.driver13ComplementaryProductId;

          if (!preferredProductId) {
            try {
              preferredProductId = sessionStorage.getItem(
                "driver13-complementary-product-id"
              );
            } catch (error) {
              // Ohne Sitzungsspeicher das erste Warenkorbprodukt nutzen.
            }
          }

          const selectedTemplate =
            templates.find(
              (template) =>
                template.dataset.productId === preferredProductId
            ) || templates[0];

          output.replaceChildren(
            selectedTemplate.content.cloneNode(true)
          );

          this.hidden = !output.querySelector(
            ".d13-cart-complementary"
          );
        });
      }

      async handleSubmit(event) {
        const form = event.target.closest("[data-complementary-form]");
        if (!form || !this.contains(form)) return;
        event.preventDefault();
        if (this.adding) return;
        const drawer = this.closest("cart-drawer");
        const button = form.querySelector('button[type="submit"]');
        const errorOutput = form.querySelector("[data-complementary-error]");
        const select = form.querySelector('select[name="id"]');
        const german = document.documentElement.lang.toLowerCase().startsWith("de");
        const originalLabel = button.textContent;
        const errorMessage = german
          ? "Das Produkt konnte nicht hinzugefügt werden. Bitte versuche es erneut."
          : "The product could not be added. Please try again.";
        this.adding = true;
        button.disabled = true;
        button.setAttribute("aria-busy", "true");
        button.textContent = german ? "Wird hinzugefügt …" : "Adding …";
        errorOutput.hidden = true;
        let added = false;
        try {
          const root = window.Shopify?.routes?.root || "/";
          const sections = drawer.getSectionsToRender().map((section) => section.id);
          const response = await fetch(root + "cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({
              items: [{
                id: select.value,
                quantity: Number(select.selectedOptions[0]?.dataset.quantity) || 1
              }],
              sections,
              sections_url: window.location.pathname
            })
          });
          const state = await response.json();
          if (!response.ok || state.status) {
            throw new Error(typeof state.description === "string" ? state.description : errorMessage);
          }
          added = true;
          if (!state.sections || sections.some((id) => !state.sections[id])) {
            throw new Error("Missing cart sections");
          }
          // Keep the original recommendation source when adding a cross-selling item.
          drawer.renderContents(state);
          drawer.setActiveElement(drawer.querySelector(".drawer__close"));
          requestAnimationFrame(() => {
            drawer.querySelector(".drawer__close")?.focus();
          });
        } catch (error) {
          if (added) {
            // Do not invite another add when only the drawer refresh failed.
            window.location.assign((window.Shopify?.routes?.root || "/") + "cart");
            return;
          }
          errorOutput.textContent = error.message || errorMessage;
          errorOutput.hidden = false;
        } finally {
          this.adding = false;
          button.disabled = false;
          button.removeAttribute("aria-busy");
          button.textContent = originalLabel;
        }
      }
    }
  );
}

